module.exports = __webpack_public_path__ + "img/nImg_0.80442ae8.png";